import React from 'react';
import ImageHelper from '@core/scripts/helper/image-helper';

export default function SourceImage({image, attributes, className, lazy, dimensions}) {

    const resolveSourceDataSrcSet = (source) => {
        return lazy ? ImageHelper.getSrcSetPathOf(source.srcSet) : null;
    };
    const resolveSourceSrcSet = (source) => {
        return lazy
            ? ImageHelper.getFallbackImageSrc()
            : source?.srcSet
            ? ImageHelper.getSrcSetPathOf(source.srcSet)
            : null;
    };
    const dataImageSrc = lazy ? image.fallbackSource.srcSet.src : null;

    const imageSrc = lazy ? ImageHelper.getFallbackImageSrc() : image.fallbackSource?.srcSet?.src;
    const sources = image?.sources?.map((source, index) => {
        return (
            <source
                key={'source-' + index}
                data-srcset={resolveSourceDataSrcSet(source)}
                media={source.mediaQuery}
                srcSet={resolveSourceSrcSet(source)}
            />
        );
    });

    return (
        <picture {...attributes} className={className}>
            {sources}
            <img
                data-src={dataImageSrc}
                src={imageSrc}
                alt={image.alt}
                title={image.title}
                width={dimensions?.width}
                height={dimensions?.height}
                className={className + (lazy ? ' lazyload' : '')}
            />
        </picture>
    );

}

